import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e7fbc84c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = {
  class: "tab-pane fade show active p-10",
  id: "home-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-3" }
const _hoisted_6 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date ", -1))
const _hoisted_8 = { class: "col-md-9" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Agent "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = {
  class: "card",
  style: {"padding":"0px !important"}
}
const _hoisted_13 = {
  class: "card-header d-flex justify-content-between align-items-center",
  style: {"background-color":"#0098c7 !important","color":"white"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title mb-0" }, "Lignes des reglements", -1))
const _hoisted_15 = { class: "card-title mb-0" }
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = {
  class: "table",
  style: {"width":"100% !important"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { style: {"width":"100% !important"} }, [
  /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"300px !important"} }, "Client"),
  /*#__PURE__*/_createElementVNode("th", null, "Montant du"),
  /*#__PURE__*/_createElementVNode("th", null, "Montant payer"),
  /*#__PURE__*/_createElementVNode("th", null, "montant restant du"),
  /*#__PURE__*/_createElementVNode("th")
], -1))
const _hoisted_19 = { style: {"margin-bottom":"5px !important"} }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = { class: "col-md-3 d-none" }
const _hoisted_24 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Total "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1))
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-md-12" }
const _hoisted_31 = { class: "d-flex align-items-center" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "elementForm",
        onSubmit: _ctx.addElement,
        "validation-schema": _ctx.elementSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_Field, {
                    name: "dateReglement",
                    type: "date",
                    modelValue: _ctx.dateReglement,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateReglement) = $event)),
                    class: "form-control shadow-none fs-md-15 text-black"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "dateReglement",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_Field, {
                    name: "utilisateur",
                    modelValue: _ctx.agentSelected,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.agentSelected) = $event))
                  }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_component_Multiselect, _mergeProps({
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                      }, field, {
                        options: _ctx.agentOptions,
                        searchable: true,
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.agentChange($event))),
                        placeholder: "Rechercher un element",
                        noResultText: "Aucun enregistrement trouvé",
                        noOptionsText: "Tapez au moins deux caractères"
                      }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "agent",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      style: {"width":"200px !important"},
                      type: "text",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchQuery) = $event)),
                      placeholder: "Rechercher...",
                      class: "form-control pt-6 pb-6 ps-25 pe-25 pt-md-5 pb-md-5 ps-md-20 pe-md-20 rounded-1 fs-md-15 fs-lg-16"
                    }, null, 512), [
                      [_vModelText, _ctx.searchQuery]
                    ]),
                    _hoisted_14,
                    _createElementVNode("h5", _hoisted_15, "Total : " + _toDisplayString(_ctx.montantTotal) + " Fcfa", 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("table", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredReglements, (reg, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_19, [
                              _createVNode(_component_Field, {
                                name: 'reg_vente' + index,
                                modelValue: reg.vente,
                                "onUpdate:modelValue": ($event: any) => ((reg.vente) = $event)
                              }, {
                                default: _withCtx(({ field }) => [
                                  _createVNode(_component_Multiselect, _mergeProps({
                                    options: _ctx.clientOptions,
                                    modelValue: field.value,
                                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                                    searchable: true,
                                    "track-by": "label",
                                    label: "label",
                                    ref_for: true
                                  }, field, {
                                    placeholder: "Sélectionnez le client",
                                    disabled: !!reg.vente
                                  }), null, 16, ["options", "modelValue", "onUpdate:modelValue", "disabled"])
                                ]),
                                _: 2
                              }, 1032, ["name", "modelValue", "onUpdate:modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: 'reg_vente' + index,
                                class: "text-danger"
                              }, null, 8, ["name"])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_Field, {
                                name: 'reg_montantDu' + index,
                                type: "text",
                                modelValue: reg.montantDu,
                                "onUpdate:modelValue": ($event: any) => ((reg.montantDu) = $event),
                                class: "form-control shadow-none fs-md-15 text-black",
                                placeholder: "0",
                                disabled: !!reg.vente
                              }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "disabled"]),
                              _createVNode(_component_ErrorMessage, {
                                name: 'reg_montantDu' + index,
                                class: "text-danger"
                              }, null, 8, ["name"])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_Field, {
                                name: 'reg_montant' + index,
                                type: "text",
                                modelValue: reg.montant,
                                "onUpdate:modelValue": ($event: any) => ((reg.montant) = $event),
                                class: "form-control shadow-none fs-md-15 text-black",
                                placeholder: "0",
                                onKeypress: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isNumber($event))),
                                onInput: ($event: any) => ((reg.montant > reg.montantDu) ? reg.montant = reg.montantDu : '')
                              }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "onInput"]),
                              _createVNode(_component_ErrorMessage, {
                                name: 'reg_montant' + index,
                                class: "text-danger"
                              }, null, 8, ["name"])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_Field, {
                                name: 'reg_restAPayer' + index,
                                type: "text",
                                modelValue: reg.restAPayer,
                                "onUpdate:modelValue": ($event: any) => ((reg.restAPayer) = $event),
                                class: "form-control shadow-none fs-md-15 text-black",
                                placeholder: "0",
                                disabled: !!reg.vente
                              }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "disabled"]),
                              _createVNode(_component_ErrorMessage, {
                                name: 'reg_restAPayer' + index,
                                class: "text-danger"
                              }, null, 8, ["name"])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-sm btn-outline-danger",
                                onClick: ($event: any) => (_ctx.removeLigne(index))
                              }, " x ", 8, _hoisted_20)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ]),
              _hoisted_21,
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_Field, {
                    name: "montantTotal",
                    type: "text",
                    modelValue: _ctx.montantTotal,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.montantTotal) = $event)),
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: "0"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "montantTotal",
                    class: "text-danger"
                  })
                ])
              ]),
              _hoisted_26,
              _hoisted_27,
              _hoisted_28
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("button", {
                  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                  type: "submit",
                  disabled: _ctx.isSubmitting
                }, [
                  (_ctx.isSubmitting)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_33))
                    : (_openBlock(), _createElementBlock("span", _hoisted_34, "Enregistrer"))
                ], 8, _hoisted_32),
                _createVNode(_component_router_link, {
                  to: "/Reglements-groupe",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [
                    _hoisted_35,
                    _hoisted_36,
                    _createTextVNode("Annuler ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}